// extracted by mini-css-extract-plugin
module.exports = {"video":"media-module--video--339VZ","loaded":"media-module--loaded--3TUQg"};